module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_sidebar),
      expression: "show_sidebar"
    }],
    attrs: {
      "id": "task-bar"
    }
  }, [(_vm.contact != null && !_vm.loading) ? _c('div', {
    staticClass: "task-bar-wrapper"
  }, [_c('div', {
    staticClass: "task-bar-header"
  }, [_c('router-link', {
    staticClass: "contacts-name link",
    attrs: {
      "to": "/contatos/" + _vm.contact.id
    }
  }, [_vm._v(_vm._s(_vm.contact.full_name))]), _c('div', {
    staticClass: "task-bar__contact-panel"
  }, [(!_vm.is_bar_minimized) ? _c('div', {
    staticClass: "clickable",
    on: {
      "click": _vm.minimize
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icons/minimizar.svg")
    }
  })]) : _vm._e(), (_vm.is_bar_minimized) ? _c('div', {
    staticClass: "clickable",
    on: {
      "click": _vm.restore
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icons/maximizar.svg")
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "clickable",
    on: {
      "click": function($event) {
        return _vm.close(_vm.contact.id)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icons/fechar.svg")
    }
  })])])], 1), (_vm.has_business) ? [_c('router-link', {
    staticClass: "company-jobs-name link",
    attrs: {
      "to": '/contatos/empresas/' + _vm.contact.business.id
    }
  }, [_vm._v(_vm._s(_vm.business_subheader))]), _c('span', {
    staticClass: "company-jobs-name"
  }, [_vm._v(_vm._s(_vm.position_subheader))])] : _c('span', {
    staticClass: "company-jobs-name"
  }, [_vm._v(_vm._s(_vm.business_subheader + _vm.position_subheader))]), (!_vm.is_bar_minimized) ? _c('div', {
    staticClass: "minimize internal-scroller"
  }, [_c('hr'), (_vm.contact.url) ? _c('a', {
    staticClass: "company-url link",
    attrs: {
      "href": _vm.absoluteUrl(_vm.contact.url),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.contact.url))]) : _c('span', {
    staticClass: "company-url"
  }, [_vm._v("-")]), _c('hr'), _c('span', {
    staticClass: "contact-email"
  }, [_vm._v(_vm._s(_vm.contact.email))]), _c('div', {
    staticClass: "telephone"
  }, [_c('span', {
    staticClass: "phone-label"
  }, [_vm._v("TELEFONE FIXO  ")]), _c('span', {
    staticClass: "phone"
  }, [_vm._v(_vm._s(_vm.contact.telephone || "-"))])]), _c('div', {
    staticClass: "celphone"
  }, [_c('span', {
    staticClass: "celphone-label"
  }, [_vm._v("CELULAR  ")]), _c('span', {
    staticClass: "phone"
  }, [_vm._v(_vm._s(_vm.contact.cellphone || "-"))])]), (_vm.contact.linkedin) ? _c('div', {
    staticClass: "social"
  }, [_c('hr'), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Social")]), _c('div', {
    staticClass: "fa fa-linkedin social-icon"
  }), _c('span', [_c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm.absoluteUrl(_vm.contact.linkedin),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.linkedin_user_name))])])]) : _vm._e(), _c('div', {
    staticClass: "flow-info"
  }, [_c('hr'), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Fluxo")]), _c('br'), (_vm.contact.flow.id) ? _c('router-link', {
    staticClass: "flow-link link",
    class: {
      underline: _vm.contact.flow
    },
    attrs: {
      "to": "/fluxos-de-cadencia/" + _vm.contact.flow.id
    }
  }, [_vm._v(_vm._s(_vm.contact.flow.name || "-"))]) : _vm._e(), (_vm.contact.flow.id) ? _c('div', {
    staticClass: "current-step"
  }, [_c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Etapa atual")]), _c('span', {
    staticClass: "flow-step"
  }, [_vm._v(_vm._s(_vm.flow_current_step_text))])]) : _c('div', {
    staticClass: "current-step"
  }, [_c('span', {
    staticClass: "subtitle"
  }, [_vm._v("-")])]), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Interações com o fluxo")]), _c('span', {
    staticClass: "sent"
  }, [_vm._v(_vm._s(_vm.interactions_count.delivery))]), _c('span', {
    staticClass: "opened"
  }, [_vm._v(_vm._s(_vm.interactions_count.open))]), _c('div', {
    staticClass: "clear"
  }), (_vm.has_open_interactions) ? [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Interações com os e-mails")]), _c('div', {
    staticClass: "flow-interations"
  }, _vm._l((_vm.contact.interactions_with_current_flow.by_flow_action), function(interaction) {
    return _c('div', {
      staticClass: "flow-iteration"
    }, [_c('span', {
      staticClass: "prospec"
    }, [_vm._v(_vm._s(_vm.flowActionDescription(interaction)))]), _c('br'), _c('span', {
      staticClass: "template-name"
    }, [_vm._v(_vm._s(_vm.templateDescription(interaction.template_subject)))]), _c('div', {
      staticClass: "times"
    }, [_vm._v(_vm._s(interaction.open) + "x")])])
  }), 0)] : _vm._e()], 2), _c('div', {
    staticClass: "comments"
  }, [_c('hr'), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.all_comments ? "Comentários" : "Último comentário"))]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "new-comment"
    },
    on: {
      "click": function($event) {
        return _vm.newComment(true)
      }
    }
  }, [_vm._v("Novo comentário")]), _c('div', {
    staticClass: "clear"
  }), (_vm.comments.length == 0) ? _c('p', [_vm._v("-")]) : _vm._e(), _vm._l((_vm.comments), function(comment) {
    return _c('div', {
      staticClass: "comment"
    }, [(comment.created_at) ? _c('span', {
      staticClass: "comment-date"
    }, [_vm._v(_vm._s(comment.created_at.format('LTS')))]) : _vm._e(), _c('br'), (!_vm.show_full_comments[comment.id]) ? _c('span', {
      staticClass: "comment-text-short"
    }, [_vm._v(_vm._s(_vm.shortDescription(comment.comment)) + "  ")]) : _c('span', {
      staticClass: "comment-text-full"
    }, [_vm._v(_vm._s(_vm.strippedContent(comment.comment)) + "  ")]), _c('br'), (comment.comment.length > _vm.description_num_of_char) ? _c('a', {
      staticClass: "see-more clickable",
      on: {
        "click": function($event) {
          return _vm.seeMoreComment(comment)
        }
      }
    }, [_vm._v(_vm._s(!_vm.show_full_comments[comment.id] ? "ver mais" : "ver menos"))]) : _vm._e(), _c('a', {
      staticClass: "edit clickable",
      on: {
        "click": function($event) {
          return _vm.editComment(comment)
        }
      }
    }, [_vm._v("Editar")])])
  }), (_vm.contact.comments.length > 1) ? _c('a', {
    staticClass: "all-comments clickable",
    class: {
      'arrow-up': _vm.all_comments
    },
    on: {
      "click": _vm.showAllComments
    }
  }, [_vm._v("todos comentários")]) : _vm._e()], 2), _c('hr'), _c('div', {
    staticClass: "tags"
  }, [_c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Tags")]), _vm._l((_vm.contact.tags), function(tag, index) {
    return _c('tag', {
      attrs: {
        "tag": tag,
        "deletable": true
      },
      on: {
        "remove-tag": _vm.removeTag
      }
    })
  }), (!_vm.current_user.isMonitoringManager()) ? _c('div', {
    staticClass: "clickable inline",
    on: {
      "click": function($event) {
        return _vm.openTagsModal()
      }
    }
  }, [(_vm.contact.tags.length == 0) ? _c('span', [_vm._v("Adicionar Tags")]) : _vm._e(), _c('div', {
    staticClass: "add-tags-btn glyphicon glyphicon-plus text-gray-color"
  })]) : _vm._e()], 2)]) : _vm._e()], 2) : _c('div', {
    staticClass: "loading-wrapper",
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d9afb8e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contacts/task_bar.vue
// module id = 1058
// module chunks = 1